export default "__VITE_ASSET__DjtacaGV__"